export default class PackageSelect {
    private static selectElements: HTMLSelectElement[] = [];
    private static currentElements: HTMLElement[] = [];

    public static init(): void {
        const allSelects = document.querySelectorAll<HTMLSelectElement>('select[name*="product_"]');
        this.selectElements = Array.from(allSelects);

        this.currentElements = Array.from(document.querySelectorAll<HTMLElement>('.current'));

        if (this.selectElements.length === 0 || this.currentElements.length === 0) {
            return;
        }

        this.selectElements.forEach((select, index) => {
            this.updateTextColor(index);
            select.addEventListener('change', () => this.updateTextColor(index));
        });
    }

    private static updateTextColor(selectIndex: number): void {
        const select = this.selectElements[selectIndex];
        const currentElement = this.currentElements[selectIndex];

        if (!select || !currentElement) {
            return;
        }

        if (select.value === '0') {
            currentElement.style.color = 'red';
        } else {
            currentElement.style.color = 'black';
        }
    }
}
